import React from 'react';
import Selector from '../util/Selector';

const STATUSES = ['TEST', 'IN_PROGRESS', 'QA', 'LIVE'];

const StatusSelector = ({ selected, onChange, disabled }) => (
  <Selector
    options={STATUSES.map((status) => ({
      id: status,
      key: status,
      display: status,
    }))}
    selected={selected ? `${selected}` : ''}
    onChange={({ target: { value } }) => onChange(value)}
    disabled={disabled}
  />
);

export default StatusSelector;
